import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PledgeFrequencySlabComponent } from './pledge-frequency-slab.component';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    PledgeFrequencySlabComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    ReactiveFormsModule
  ],
  exports: [
    PledgeFrequencySlabComponent
  ]
})

export class PledgeFrequencySlabModule { }
